import AUTH_ACTIONS from '../../constants/actions/auth';
import {STATUS_SERVICE} from '../../constants/app/services'
import { ROLES } from '../../constants/user';
import User from '../../lib/utils/transforms/user';

const defaultState = {
    statusLogin: STATUS_SERVICE.INITIAL,
    logoutOk: false,
    token: {},
    loginSetOk: false,
    statusReport: STATUS_SERVICE.INITIAL,
    url: '',
    isViewer: false
};
const AuthReducer = (state = defaultState, action) => {
    switch (action.type) {
		case AUTH_ACTIONS.LOGIN_RESET:
			return {
                ...state,
                statusLogin: STATUS_SERVICE.INITIAL,
                statusMe: STATUS_SERVICE.INITIAL,
                logoutOk: false,
                token: {},
                loginSetOk: false,
            }
        case AUTH_ACTIONS.TOKEN_LOADED: 
            return {
				...state,
                loginSetOk: true
            }
        case AUTH_ACTIONS.LOGIN:
            return {
                ...state,
                statusLogin: STATUS_SERVICE.INPROGRESS,
                error: null
            };
        case AUTH_ACTIONS.LOGIN_ERROR:
            return {
                ...state,
                statusLogin: STATUS_SERVICE.ERROR,
                error: action.payload
            };
        case AUTH_ACTIONS.LOGIN_OK:
            return {
                ...state,
                statusLogin: STATUS_SERVICE.SUCCESS,
                statusMe: STATUS_SERVICE.SUCCESS,
                token: action.payload
            };
        case AUTH_ACTIONS.LOGOUT:
            return {
                ...state,
                logoutOk: false
            }
        case AUTH_ACTIONS.LOGOUT_OK:
            return {
                ...state,
                logoutOk: true,
                statusMe: STATUS_SERVICE.INPROGRESS,
                token: {},
                loginSetOk: false,
                statusLogin: STATUS_SERVICE.INITIAL,
            } 
        case AUTH_ACTIONS.ME:{
            return {
                ...state,
                statusMe: STATUS_SERVICE.INPROGRESS
            };
        }
        case AUTH_ACTIONS.ME_OK:{
            return {
                ...state,
                user: action.payload,
                statusMe: STATUS_SERVICE.SUCCESS,
                isViewer: User.validateRol(action.payload.authorities)
            };
        }
        case AUTH_ACTIONS.ME_ERROR:{
            return {
                ...state,
                statusMe: STATUS_SERVICE.ERROR
            };
        }
        case AUTH_ACTIONS.ME_RESET:{
            return {
                ...state,
                statusMe: STATUS_SERVICE.INITIAL
            };
        }
        case AUTH_ACTIONS.RESET_LOGOUT_OK: {
            return {
                ...state,
                logoutOk: false
            };
        }
        // obtener reporte de inspecciones
        case AUTH_ACTIONS.LOAD_INSPECTION_REPORT:
        return {
            ...state,
                ...state,
                statusReport: STATUS_SERVICE.INPROGRESS
        }
        case AUTH_ACTIONS.LOAD_INSPECTION_REPORT_OK:
            return {
                ...state,
                    ...state,
                    statusReport: STATUS_SERVICE.SUCCESS,
                    url: action.payload.response
            }
        case AUTH_ACTIONS.LOAD_INSPECTION_REPORT_ERROR:
            return {
                ...state,
                    ...state,
                    statusReport: STATUS_SERVICE.ERROR
            }
        case AUTH_ACTIONS.LOAD_INSPECTION_REPORT_RESET:
            return {
                ...state,
                    ...state,
                    statusReport: STATUS_SERVICE.INITIAL,
                    url: {}
            }
        default:
            return state;
    }
};

export default AuthReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/auth.js